import { apiClient, getAuthToken } from '@/shared/data/client';
import {
  mapCoverageRunDto,
  mapCoverageRunSummaryDto,
  mapQueryResult,
} from '@/shared/data/dtoMappers';
import type {
  CoverageRunDto,
  CoverageRunSummaryDto,
  QueryFilter,
  QueryResult,
} from '@flowqa/shared';

type CoverageRunQueryRequest = {
  page: number;
  pageSize: number;
  filters?: QueryFilter[];
  sorts?: Array<{ field: string; direction: 'asc' | 'desc' }>;
};

export const queryCoverageRuns = async (
  input: CoverageRunQueryRequest,
  orgId?: string | null,
): Promise<QueryResult<CoverageRunDto>> => {
  const result = await apiClient.post<QueryResult<CoverageRunDto>>('coverage-runs/query', input, {
    orgId,
  });
  return mapQueryResult(result, mapCoverageRunDto);
};

export const queryCoverageRunSummary = async (
  input: CoverageRunQueryRequest,
  orgId?: string | null,
): Promise<CoverageRunSummaryDto> =>
  mapCoverageRunSummaryDto(
    await apiClient.post<CoverageRunSummaryDto>('coverage-runs/summary', input, { orgId }),
  );

export const getCoverageRunById = async (
  id: string,
  orgId?: string | null,
): Promise<CoverageRunDto> =>
  mapCoverageRunDto(await apiClient.get<CoverageRunDto>(`coverage-runs/${id}`, { orgId }));

export const deleteCoverageRun = async (
  input: { id: string },
  orgId?: string | null,
): Promise<void> => {
  await apiClient.post<undefined>(`coverage-runs/${input.id}/delete`, undefined, { orgId });
};

export const updateCoverageRunTags = async (
  input: { id: string; tags?: string[] },
  orgId?: string | null,
): Promise<CoverageRunDto> =>
  mapCoverageRunDto(
    await apiClient.post<CoverageRunDto>(
      `coverage-runs/${input.id}/tags`,
      { tags: input.tags },
      {
        token: getAuthToken(),
        orgId,
      },
    ),
  );
